import { IconButton, Tooltip } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import React, { useState } from "react";
import { FiClipboard } from "react-icons/fi";

import * as Styles from "./styles";

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  status: "loading" | "error" | "success" | "none" | null;
  onChange: (e: any) => void;
  label: string;
  value: string;
}

const CustomInput: React.FC<Props> = ({
  status,
  onChange,
  label,
  value,
  ...props
}) => {
  const [focused, setFocused] = useState<boolean>(false);

  const handlePaste = () => {
    navigator.clipboard
      .readText()
      .then((text) => {
        onChange(text);
        console.log("Conteúdo colado:", text);
      })
      .catch((error) => {
        console.error("Erro ao colar:", error);
      });
  };

  const generateIcon = () => {
    switch (status) {
      case "loading":
        return (
          <Styles.Icon>
            <CircularProgress size={16} style={{ marginRight: 9 }} />
          </Styles.Icon>
        );

      case "success":
        return (
          <Styles.Icon>
            <Styles.Dot color="#4CAF50" />
          </Styles.Icon>
        );
      case "error":
        return (
          <Styles.Icon>
            <Styles.Dot color="#F43636" />
          </Styles.Icon>
        );
      default:
        return null;
    }
  };

  const generateText = () => {
    switch (status) {
      case "loading":
        return (
          <Styles.TextStatus color="#A3A3A6">
            Validando ID, aguarde...
          </Styles.TextStatus>
        );
      case "success":
        return <Styles.TextStatus color="#4CAF50">ID Válido</Styles.TextStatus>;
      case "error":
        return (
          <Styles.TextStatus color="#F43636">
            ID inválido, verifique o código e tente novamente!
          </Styles.TextStatus>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Styles.Label>{label}</Styles.Label>
      <Styles.Container focused={focused}>
        {value?.length > 5 ? generateIcon() : null}
        <Styles.CustomInput
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onChange={(e: any) => onChange(e.target.value)}
          value={value}
          {...props}
        />
        <Tooltip title="Colar" followCursor arrow placement="top">
          <IconButton onClick={() => handlePaste()}>
            <FiClipboard size={18} />
          </IconButton>
        </Tooltip>
      </Styles.Container>
      {value?.length > 5 ? generateText() : null}
    </>
  );
};

export default CustomInput;
